export default {
  title: '商城裝修',
  previewTitle: '商城中心',
  pageSetting: '頁面設置',
  pageTitle: '頁面標題',
  pageTitlePlaceholder: '請輸入頁面標題',
  defaultPageTitle: '個人中心',
  modules: '功能模組',
  moduleList: '模組列表',
  moduleConfig: '模組配置',
  editText: '編輯文字',
  editTextTitle: '編輯文字',
  moduleNames: {
    Banner: '輪播圖',
    Picture: '圖片櫥窗',
  },
  labelName: {
    pointName: '積分',
  },
  // 頂部語言版本
  langSection: '語言版本',
  langEnglish: 'English',
  langZhTw: '繁體中文',
  langZhCn: '簡體中文',
  langJaJp: 'Japanese',
  // 右側 Tabs
  tabs: {
    title: '頁面標題',
    carousel: '輪播圖',
    showcase: '圖片櫥窗',
  },
  delete: '刪除',
  // 輪播圖
  image: '圖片',
  show: '顯示',
  hide: '隱藏',
  carouselTip: '最多支持上傳 5 張圖片，如果隱藏則不顯示上傳圖片入口並且終端也不顯示頂部的圖片',
  uploadImage: '上傳圖片',
  // 圖片櫥窗
  layout: '佈局',
  layoutAlone: '獨佔一行',
  layoutBigOne: '大圖一行',
  layoutStack2: '堆積兩行',
  unit: '單位',
  unitPlaceholder: '請輸入單位',
  // 預覽區固定文案
  previewBack: '返回',
  previewExchange: '立馬兌換',
  previewAll: '全部',
  mockItemTitle: '商品名稱{index}',
  // 操作
  save: '保存',
  saveSuccess: '保存成功',
  syncConfig: '同步配置',
  syncConfigTitle: '同步配置',
  syncConfigDesc: '將當前語言（{lang}）的配置同步到以下語言：',
  syncConfigSuccess: '同步成功',
  formLabel: {
    isShow: '是否顯示',
    show: '顯示',
    hide: '隱藏',
    image: '圖片',
    layoutType: '佈局類型',
    layoutAlone: '獨佔一行',
    layoutBigOne: '大圖一行',
    layoutStack2: '堆積兩列',
  },
};
